import { render } from "./DeliveredOrders.vue?vue&type=template&id=673371a2&scoped=true"
import script from "../js/delivered-orders.js?vue&type=script&lang=js&external"
export * from "../js/delivered-orders.js?vue&type=script&lang=js&external"

import "./DeliveredOrders.vue?vue&type=style&index=0&id=673371a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673371a2"]])

export default __exports__